export default __webpack_public_path__ + "static/media/Request.c198f764.svg";